// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ZoomPanPinch_Wrapper__uTT1d","Content":"ZoomPanPinch_Content__SvKTK"};